export default __webpack_public_path__ + "static/media/joinLogo.b203abbf.png";